import { Product } from "./activeEntityType";
import { BuildNode, orderStatus } from "./types";

export type ChildrenFilteringFunction = (
    children: BuildNode[], //for future use / more complex filtering
    data?: Record<string, unknown> | string
) => number;

export const conditionFilterFunctions = {
    filterByOrderStatus: (_: BuildNode[], order: Record<any, any>) => {
        const currentStatus = order?.status?.toLowerCase() || "";
        const statusToIndex: Partial<Record<orderStatus, number>> = {
            "completed": 0,
            "refunded": 1,
            "partial-refund": 2,
            "parked": 3
        }
        if (currentStatus in statusToIndex) {
            return statusToIndex[currentStatus as orderStatus];
        }
        return 0;
    },
    filterByIsDataSetEmpty: (_: BuildNode[], dynamicDataSet: Record<string, unknown>[]) => {
        return !dynamicDataSet || dynamicDataSet.length === 0 ? 1 : 0; // returns second child if dynamicDataSet is empty to allow empty state mode
    },
    filterFirstChild: () => {
        return 0;
    },
    filterByProductType: (_: BuildNode[], product: Product) => {
        return product?.productType === "simple" ? 0 : 1;
    }
};

export type ConditionFilterFunctionKeys = keyof typeof conditionFilterFunctions;
